/**
 * Phase 3.67 — Werbemittel-Unterseite (Marketing-Bereich des Händlers).
 *
 * Vollbild-Ansicht der bestehenden WerbemittelSection mit eigener Route
 * (`/dealer/werbemittel`), damit der Händler die Marketing-Werbemittel
 * in größerem Layout bearbeiten und referenzieren kann.
 */
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ArrowLeft, Megaphone } from "lucide-react";
import { Button } from "../components/ui/button";
import { WerbemittelSection } from "../components/dealer/WerbemittelSection";

export default function DealerWerbemittelPage() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    if (loading) return <div className="p-12">Lade…</div>;
    if (!user || user.role !== "b2b") {
        return (
            <div className="max-w-3xl mx-auto p-8" data-testid="werbemittel-page-forbidden">
                <h1 className="font-display text-2xl font-bold mb-4">Nicht verfügbar</h1>
                <p className="text-gray-700">Die Werbemittel-Seite ist nur für Händler-Accounts zugänglich.</p>
                <Button onClick={() => navigate("/")} className="mt-4">Zur Startseite</Button>
            </div>
        );
    }

    return (
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-8 md:py-12" data-testid="dealer-werbemittel-page">
            <button
                onClick={() => navigate("/dashboard?tab=settings")}
                className="inline-flex items-center gap-1.5 text-sm font-bold text-gray-600 hover:text-[#111827] mb-4"
                data-testid="werbemittel-back-btn"
            >
                <ArrowLeft className="w-4 h-4" /> Zurück zu den Einstellungen
            </button>
            <div className="flex items-center gap-3 mb-2">
                <Megaphone className="w-7 h-7 text-[#FFCC00]" />
                <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Werbemittel</h1>
            </div>
            <p className="text-gray-600 mb-8">
                Banner, Landingpage, QR-Smiley und Anzeigen auf twowheels.info — fertig generiert mit Ihrem Transaktions-Code.
            </p>
            <div className="bg-white border border-gray-200 rounded-sm p-6 md:p-8">
                <WerbemittelSection currentUser={user} />
            </div>
        </div>
    );
}
